import React, { useMemo } from 'react';
import { Button, Text } from 'vkit/lib/components';
import { Grid, Tooltip } from 'vkit/lib/context';

interface ButtonSaveEditionProps {
  countEditedRow: number;
  countRowWithError: number;
  onClick: () => void;
  loading: boolean;
}

export const ButtonSaveEdition: React.FC<ButtonSaveEditionProps> = ({
  countEditedRow,
  countRowWithError,
  onClick,
  loading,
}) => {
  const canSaveEdition = useMemo(
    () => countEditedRow >= countRowWithError,
    [countEditedRow, countRowWithError],
  );
  const textCountEditedRow = useMemo(() => {
    if (countEditedRow === 0) {
      return 'Nenhum arquivo editado';
    }

    if (countEditedRow === 1) {
      return '1 arquivo editado';
    }

    return `${countEditedRow} arquivos editados`;
  }, [countEditedRow]);

  return (
    <Grid alignContent='right' alignItems='center' gap={16}>
      <Text size='medium' value={`${textCountEditedRow} de ${countRowWithError} com erro`} />

      <Tooltip
        title={
          canSaveEdition ? undefined : 'Edite todos os arquivos antes de salvar as alterações'
        }>
        <Button
          label='Salvar alterações'
          outlined
          disabled={!canSaveEdition}
          onClick={onClick}
          loading={loading}
        />
      </Tooltip>
    </Grid>
  );
};
